const actionPrefix = "API_";
export const NETWORK_WARNINGS_ACTIVE = actionPrefix + "NETWORK_WARNINGS_ACTIVE";
export const NETWORK_WARNINGS_INACTIVE =
  actionPrefix + "NETWORK_WARNINGS_INACTIVE";